import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class QuantityBreakLabelService {
  /**
   * Returns a label for the quantity break.
   * If the array has more than one item, prepends a '+' to the first item's quantityBreak.
   * @param value Array of objects with a quantityBreak property
   * @returns string label
   */
  getQuantityBreakLabel(value: { quantity: string | number }[]): string {
    if (!value || value.length === 0) {
      return '';
    }
    return value.length > 1 ? `${value[0].quantity}+` : `${value[0].quantity}`;
  }
}
